import { useMutation } from '@tanstack/react-query'
import axios from '@/lib/axios'
import { PasswordResetRequestParams, ResetPasswordParams } from '@/types/auth'

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (params: PasswordResetRequestParams) => axios.post('/auth/password', params)
  })
}

export const useResetPassword = (token: string) => {
  return useMutation({
    mutationFn: (params: ResetPasswordParams) => axios.post(`/auth/password/${token}`, params)
  })
}

export const useVerifyEmail = () => {
  return useMutation({
    mutationFn: (token: string) => axios.get(`/auth/email-verification/${token}`)
  })
}
